import mixpanel from 'mixpanel-browser';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Provider } from 'Utils/mixpanel';
import ProjectConfig from 'ProjectConfig';

const config = {
  batch_requests: ProjectConfig.MIXPANEL.batch_requests,
  debug: ProjectConfig.DEBUG,
  persistence: 'localStorage',
  flags: true,
};

const MixpanelProvider = ({ children }) => {
  
  mixpanel.init(ProjectConfig.MIXPANEL.token, config);
  
  mixpanel.register({
    Platform: 'Mobil'
  });

  window.mixpanel = mixpanel;
  
  const auth = useSelector(state => state.auth);
  
  useEffect( () => {
    if (auth.isAuthenticated && auth.data?.externalCustomerId) {
      mixpanel.identify(auth.data.externalCustomerId);
    }
  }, [auth.isAuthenticated]);
  
  return (
    <Provider value={ mixpanel }>
      { children }
    </Provider>
  );
};

MixpanelProvider.propTypes = {
  children: PropTypes.node,
  config: PropTypes.object,
  token: PropTypes.string
};

export default MixpanelProvider;
